import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import SmsRoundedIcon from "@mui/icons-material/SmsRounded";
export default function UpdatePasswordSMSSent(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue}>
      <div style={iconContainerStyle}>
        <SmsRoundedIcon style={successIconStyle} />
      </div>
      <Div margin={tenzero}>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          {"SMS Sent"}
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          {"A message has been sent. Please check your phone for the SMS."}
        </Text>
      </Div>
      <Div margin={tenzero}>
        <ModalButton onClick={props.handler}>Close</ModalButton>
      </Div>
    </ModalDisplay>
  );
}
const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
